// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2710%27 height=%2716%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg fill=%27%232D4053%27 stroke=%27%232D4053%27 stroke-width=%27.5%27 fill-rule=%27evenodd%27%3E%3Cpath d=%27M4.687 15.315a.443.443 0 0 0 .626 0l3.557-3.556a.446.446 0 0 0-.629-.629L5 14.37l-3.241-3.24a.445.445 0 0 0-.629.63l3.557 3.553v.002ZM5.313 1.13a.443.443 0 0 0-.626 0L1.13 4.685a.446.446 0 0 0 .629.63L5 2.074l3.241 3.24a.445.445 0 0 0 .629-.629L5.313 1.131V1.13Z%27/%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__eJCMb {
  position: relative;
}
.dropdownContainer__Ekar9 {
  width: 100%;
}
.selectorBox__ieMiX {
  display: flex;
  align-items: center;

  /* Dimensions */
  width: 100%;
  min-height: 48px;
  margin: 0;

  /* 6 + 24 + 4 + borders are divisible by 6 */
  padding: 6px 12px 4px 12px;
  background-color: #fff;

  /* Borders */
  border-radius: 6px;
  border: 1px solid #d8dce6;
  outline: none;

  padding: 6px 24px 4px 12px;

  /* Unset user agent styles */
  appearance: none;

  /* Background */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center right 12px;
  background-size: 8px 14px;

  font-family: var(--fontFamily);
  font-size: 16px;
  font-weight: var(--fontWeightRegular);

  @media (min-width: 768px) {
    padding: 7px 32px 7px 16px;
    background-position: center right 16px;
    background-size: 10px 16px;
  }
}
/* Effects */
.selectorBox__ieMiX:hover {
  border: 1px solid #b8bfd1;
  transition: all ease-in-out 100ms;
}
.selectorBox__ieMiX:focus {
  background-color: #fff;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
  transition: all ease-in-out 100ms;
}
.selectorBox__ieMiX:disabled {
  opacity: 0.5;

  &:hover {
    cursor: not-allowed;
  }
}
.selectedItem__JkLTs {
  padding: 0;
}
.listingDropdown__VjgfH {
  z-index: 1;
  position: absolute;
  top: calc(100% + 2px);

  display: flex;
  flex-direction: column;

  border: 1px solid #d8dce6;
  border-radius: var(--borderRadiusMedium);
  width: 100%;
  max-height: 175px;

  overflow-y: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  background-color: var(--colorWhite);
}
`, "",{"version":3,"sources":["webpack://./src/components/ListingSelector/ListingSelector.module.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,WAAW;AACb;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,SAAS;;EAET,4CAA4C;EAC5C,0BAA0B;EAC1B,sBAAsB;;EAEtB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;;EAEb,0BAA0B;;EAE1B,4BAA4B;EAC5B,gBAAgB;;EAEhB,eAAe;EACf,yDAAwe;EACxe,sCAAsC;EACtC,yBAAyB;;EAEzB,8BAA8B;EAC9B,eAAe;EACf,qCAAqC;;EAErC;IACE,0BAA0B;IAC1B,sCAAsC;IACtC,0BAA0B;EAC5B;AACF;AACA,YAAY;AACZ;EACE,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,6CAA6C;EAC7C,iCAAiC;AACnC;AACA;EACE,YAAY;;EAEZ;IACE,mBAAmB;EACrB;AACF;AAEA;EACE,UAAU;AACZ;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,qBAAqB;;EAErB,aAAa;EACb,sBAAsB;;EAEtB,yBAAyB;EACzB,wCAAwC;EACxC,WAAW;EACX,iBAAiB;;EAEjB,gBAAgB;EAChB,wCAAwC;;EAExC,mCAAmC;AACrC","sourcesContent":["@import '../../styles/customMediaQueries.css';\n\n.root {\n  position: relative;\n}\n\n.dropdownContainer {\n  width: 100%;\n}\n\n.selectorBox {\n  display: flex;\n  align-items: center;\n\n  /* Dimensions */\n  width: 100%;\n  min-height: 48px;\n  margin: 0;\n\n  /* 6 + 24 + 4 + borders are divisible by 6 */\n  padding: 6px 12px 4px 12px;\n  background-color: #fff;\n\n  /* Borders */\n  border-radius: 6px;\n  border: 1px solid #d8dce6;\n  outline: none;\n\n  padding: 6px 24px 4px 12px;\n\n  /* Unset user agent styles */\n  appearance: none;\n\n  /* Background */\n  background-image: url(\"data:image/svg+xml,%3Csvg width='10' height='16' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%232D4053' stroke='%232D4053' stroke-width='.5' fill-rule='evenodd'%3E%3Cpath d='M4.687 15.315a.443.443 0 0 0 .626 0l3.557-3.556a.446.446 0 0 0-.629-.629L5 14.37l-3.241-3.24a.445.445 0 0 0-.629.63l3.557 3.553v.002ZM5.313 1.13a.443.443 0 0 0-.626 0L1.13 4.685a.446.446 0 0 0 .629.63L5 2.074l3.241 3.24a.445.445 0 0 0 .629-.629L5.313 1.131V1.13Z'/%3E%3C/g%3E%3C/svg%3E\");\n  background-position: center right 12px;\n  background-size: 8px 14px;\n\n  font-family: var(--fontFamily);\n  font-size: 16px;\n  font-weight: var(--fontWeightRegular);\n\n  @media (--viewportMedium) {\n    padding: 7px 32px 7px 16px;\n    background-position: center right 16px;\n    background-size: 10px 16px;\n  }\n}\n/* Effects */\n.selectorBox:hover {\n  border: 1px solid #b8bfd1;\n  transition: all ease-in-out 100ms;\n}\n.selectorBox:focus {\n  background-color: #fff;\n  border-color: #80bdff;\n  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);\n  transition: all ease-in-out 100ms;\n}\n.selectorBox:disabled {\n  opacity: 0.5;\n\n  &:hover {\n    cursor: not-allowed;\n  }\n}\n\n.selectedItem {\n  padding: 0;\n}\n\n.listingDropdown {\n  z-index: 1;\n  position: absolute;\n  top: calc(100% + 2px);\n\n  display: flex;\n  flex-direction: column;\n\n  border: 1px solid #d8dce6;\n  border-radius: var(--borderRadiusMedium);\n  width: 100%;\n  max-height: 175px;\n\n  overflow-y: auto;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\n  background-color: var(--colorWhite);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__eJCMb`,
	"dropdownContainer": `dropdownContainer__Ekar9`,
	"selectorBox": `selectorBox__ieMiX`,
	"selectedItem": `selectedItem__JkLTs`,
	"listingDropdown": `listingDropdown__VjgfH`
};
export default ___CSS_LOADER_EXPORT___;
